/* eslint-disable no-unsafe-optional-chaining */
import { NError, NSuccess } from '@configs/const.config'
import { TResApi, TResApiErr, TResDataListApi } from '@configs/interface.config'
import { checkAuth } from '@libs/localStorage'
import { TAccount, TPatchAccount, TQueryAccount } from '@src/modules'
import { notification } from 'antd'
import { useMutation, useQuery } from 'react-query'

import { queryClient } from '..'
import {
  getAccountById,
  getListAccount,
  patchAccountById,
  postAccount,
  removeAccountById,
  removeManyAccountByIds,
} from '../apis'
import { DETAIL_ACCOUNT, LIST_ACCOUNT } from '../keys'

/**
 * @method useQueryListAccount
 * @param params
 * @param token
 * @returns
 */
export const useQueryListAccount = (params: TQueryAccount, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResDataListApi<TAccount[]>>(
    [LIST_ACCOUNT, JSON.stringify(params)],
    () => getListAccount(params, accessToken),
    {
      enabled: !!accessToken,
    },
  )
}

/**
 * @method useQueryAccountById
 * @param id
 * @param token
 * @returns
 */
export const useQueryAccountById = (id: string, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TAccount>>([DETAIL_ACCOUNT, id], () => getAccountById(id, accessToken), {
    enabled: !!accessToken && !!id,
  })
}

/**
 * @method useMutationPostAccount
 * @returns
 */
export const useMutationPostAccount = () =>
  useMutation(postAccount, {
    onSuccess: (res: TResApi<TAccount>) => {
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 * @method useMutationPatchAccountById
 * @returns
 */
export const useMutationPatchAccountById = () =>
  useMutation(({ id, data }: { id: string; data: TPatchAccount }) => patchAccountById(id, data), {
    onSuccess: (res: TResApi, { id }) => {
      queryClient.refetchQueries([LIST_ACCOUNT]).then()
      queryClient.invalidateQueries([DETAIL_ACCOUNT, id]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

export const useMutationRemoveAccountById = () =>
  useMutation(removeAccountById, {
    onSuccess: (res: TResApi, id) => {
      queryClient.refetchQueries([LIST_ACCOUNT]).then()
      queryClient.removeQueries([DETAIL_ACCOUNT, id])
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 * @method useMutationRemoveManyAccountByIds
 * @returns
 */
export const useMutationRemoveManyAccountByIds = () =>
  useMutation(removeManyAccountByIds, {
    onSuccess: (res: TResApi) => {
      queryClient.refetchQueries([LIST_ACCOUNT]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
  })

// export const useMutationImportAccount = () => {
//   const accessToken = checkAuth()
//   return useMutation((data: FormData) => importAccount(data, accessToken), {
//     onError: (error: TResApiErr) => {
//       // [TODO] ...
//       notification.error({ message: NError, description: error?.message })
//     },
//   })
// }
